import Swiper from 'swiper/swiper-bundle.min';
export default (function () {
  var slider;

  function mobileSliderTestInit() {
    slider = new Swiper('.testimonials-slider .swiper-container', {
      slidesPerView: 1.5,
      direction: 'horizontal',
      spaceBetween: 2,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev'
      },
      pagination: {
        el: '.testimonials-slider .swiper-pagination',
        type: 'bullets',
        clickable: true
      },
      speed: 1000,
      breakpoints: {
        480: {
          slidesPerView: 2,
          spaceBetween: 2
        },
        640: {
          slidesPerView: 1,
          spaceBetween: 2
        },
        768: {
          slidesPerView: 2,
          spaceBetween: 2
        },
        1200: {
          slidesPerView: 3,
          spaceBetween: 2
        }
      }
    });
  }

  mobileSliderTestInit();
});